export default "__VITE_ASSET__fBWQ5_Nf__"